import { Box } from "@mui/material";
import React from "react";

import { IconSize, iconSize } from "../../theme/designTokens";

export type IconType =
  | "rocket"
  | "home"
  | "practitioner"
  | "patient"
  | "location"
  | "device"
  | "entity"
  | "chevron-right-filled"
  | "close"
  | "save"
  | "group";

interface IconProps {
  type: IconType;
  alt?: string;
  size?: IconSize;
}

export const Icon: React.FC<IconProps> = ({ type, size = "small", alt }) => {
  const iconSizeValue = iconSize[size];
  return (
    <Box component="img" src={`/images/${type}-icon.svg`} alt={alt} width={iconSizeValue} height={iconSizeValue} />
  );
};
